import { COLORS } from '@cocolocala/ui-components';
import { createFontStyle, MOBILE_FONT_STYLES } from '@cocolocala/ui-components';
import { CocoRedButton } from '@cocolocala/ui-components';
import { CocoDivider } from '@cocolocala/ui-components';
import { styled } from 'linaria/react';
import get from 'lodash/get';
import Link from 'next/link';
import React, { CSSProperties, FC } from 'react';
import InputField from '~/shared/components/shared/InputField';
import AgreeTermsOfUseAndPrivacyPolicy from '~/shared/components/shared/SignForm/AgreeTermsOfUseAndPrivacyPolicy';
import Spacer from '~/shared/components/shared/Spacer';
import { LoggingLabel } from '~/utils/constants';
import { logger } from '~/utils/loggerUtil';
import { sendOrderFormInputLog } from '~/utils/logging';
import IconForgot from './iconForgot';
import { SignFormType, useLocalState } from './useLocalState';
import ValidationCheck from './validationCheck';
type Props = {
  formType: 'sign-up' | 'sign-in';
  submitButtonLabel: string;
  queryParameters?: string;
  onSubmit?: (formData: SignFormType) => void;
  style?: CSSProperties;
};
const SignForm: FC<Props> = ({
  formType,
  submitButtonLabel,
  queryParameters,
  onSubmit,
  style
}) => {
  const {
    register,
    errors,
    handleSubmit,
    setValue,
    trigger,
    agreedValue,
    onClickAgreeButton,
    suggestedEmailList,
    setOnFocusEmail,
    onFocusEmail,
    passwordValidations
  } = useLocalState();
  return <form onSubmit={handleSubmit(data => {
    onSubmit?.(data);
  })}>
      <Container>
        <FloatingWrapper style={style}>
          <InputSectionMini>メールアドレス</InputSectionMini>
          <InputField name="email" type="email" autoComplete="username" placeholder="email@cocolocala.jp" require errorMessage={onFocusEmail && suggestedEmailList.length > 0 ? undefined : get(errors, 'email.message')} inputRef={register} onFocus={() => {
          setOnFocusEmail(true);
        }} onBlur={e => {
          // focusがハズレて遅延させてstateを変える（じゃないとサジェストがタッチできない）
          setTimeout(() => {
            setOnFocusEmail(false);
          }, 1000);

          // Send Log
          sendOrderFormInputLog(LoggingLabel.ORDER_FORM_INPUT_BLUR_MAIL_ADDRESS, 'text', e.currentTarget.value?.length).catch(e => logger.error('fail logging', e));
        }} />

          {/* メールのサジェスト */}
          {onFocusEmail && suggestedEmailList.length > 0 && <SuggestBox>
              {suggestedEmailList.map((suggested, index) => {
            return <React.Fragment key={index}>
                    {index > 0 && <CocoDivider />}
                    <Suggest key={suggested} onClick={() => {
                setValue('email', suggested);
                trigger('email');
              }}>
                      <span>{suggested}</span>
                    </Suggest>
                  </React.Fragment>;
          })}
            </SuggestBox>}

          {/* メールを受け取れるよう注意文 */}
          <InputContainer>
            <InputSectionMini>パスワード</InputSectionMini>
            <InputField name="password" type="password" autoComplete={formType === 'sign-in' ? 'current-password' : 'new-password'} require errorMessage={get(errors, 'password.message')} inputRef={register} placeholder={'●●●●●●●●'} onBlur={e => {
            // Send Log
            sendOrderFormInputLog(LoggingLabel.ORDER_FORM_INPUT_BLUR_PASSWORD, 'text', e.currentTarget.value?.length).catch(e => logger.error('fail logging', e));
          }} />
            {formType === 'sign-up' && <>
                <Spacer vertical="10px" />
                {/* パスワードのバリデーション */}
                {passwordValidations.map((validation, index) => <ValidationCheck key={index} {...validation} />)}
              </>}

            {/* 利用規約、プライバシーポリシーへの同意 */}
            {formType === 'sign-up' && <AgreeTermsOfUseAndPrivacyPolicy agree={agreedValue} onClickAgree={onClickAgreeButton} agreeErrorMessage={get(errors, `agreeTermsOfUseAndPrivacyPolicy.message`)} style={{
            marginTop: '20px'
          }} />}

            <CocoRedButton style={{
            margin: '20px 0 0'
          }} width={'100%'} height={'50px'} textSize={16}>
              {submitButtonLabel}
            </CocoRedButton>
          </InputContainer>
          {formType === 'sign-in' && <ForgotPasswordContainer>
              <Link href={'/sign/forgot-password' + (typeof queryParameters !== 'undefined' ? `?${queryParameters}` : '')} passHref={true} legacyBehavior>
                <ForgotPasswordLink>
                  <ForgotPassword>
                    <IconForgot />
                    パスワードを忘れた場合はこちら
                  </ForgotPassword>
                </ForgotPasswordLink>
              </Link>
            </ForgotPasswordContainer>}
        </FloatingWrapper>
      </Container>
    </form>;
};
export default SignForm;
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c19ukc20"
});
const FloatingWrapper = /*#__PURE__*/styled("div")({
  name: "FloatingWrapper",
  class: "f60pk4z"
});
const InputSectionMini = /*#__PURE__*/styled("p")({
  name: "InputSectionMini",
  class: "i1pa5wo6"
});
const InputContainer = /*#__PURE__*/styled("div")({
  name: "InputContainer",
  class: "i1o8rt25"
});
const SuggestBox = /*#__PURE__*/styled("div")({
  name: "SuggestBox",
  class: "s1qfhtfr"
});
const Suggest = /*#__PURE__*/styled("p")({
  name: "Suggest",
  class: "sz4m03p"
});
const ForgotPasswordLink = /*#__PURE__*/styled("a")({
  name: "ForgotPasswordLink",
  class: "f1yvewng"
});
const ForgotPassword = /*#__PURE__*/styled("div")({
  name: "ForgotPassword",
  class: "f2hcsnt"
});
const ForgotPasswordContainer = /*#__PURE__*/styled("div")({
  name: "ForgotPasswordContainer",
  class: "fmwbi4s"
});
const UnAvailableMemberDiscountDescription = /*#__PURE__*/styled("p")({
  name: "UnAvailableMemberDiscountDescription",
  class: "uh67o79"
});

require("./index.linaria.module.css!=!../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");